// Module
var code = "<div class=\"cover__title\"> <h2 class=\"cover__title__text sofia bold uppercase\"></h2> </div> <template id=\"cover__image-template\"> <div class=\"cover__image image\"></div> </template> ";
// Exports
export default code;